import { styled } from "baseui";
import TimelineItem from "./TimelineItem";
import React from 'react'

const Timeline = (props: any) => {
    return (
        <TimelineContainer >
            <CenterLine></CenterLine>
            {React.Children.map(props.children, (v, idx) => (
                <TimelineItem evenOdd={idx % 2 === 0} {...v.props} key={idx} >
                    {React.cloneElement(v, { style: { ...v.props.style, opacity: 0.5 } })}
                </TimelineItem>))
                }
        </TimelineContainer>
    )
};

export default Timeline;


const TimelineContainer = styled("div", {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
});

const CenterLine = styled("div", ({ $theme }) => ({
    backgroundColor: $theme.colors.accent100,
    content: '',
    position: 'absolute',
    left: `calc(50% - 1px)`,
    width: '2px',
    height: '100%'
}));